export default function pauseVideo(node_url) {
    return fetch(`${node_url}/keycode/88/d`);
}
